import { mapDTO } from '@twistezo/ts-dto-mapper'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { DomainBidderAlert } from 'features/globalSetup/api/types/domainBidderAlert'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { DomainBidderSlice } from '../types'
import { DomainBidderSliceDTO } from './types'
import { mapParametersSchema } from './utils'

type From = DomainBidderSliceDTO
type To = DomainBidderSlice

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((domainBidder: From): To => {
    const {
      csSchema,
      domain: { alerts, ...domain },
      fieldAlerts,
      s2sSchema,
    } = domainBidder

    return {
      ...domainBidder,
      alerts: alertsFromDTO<DomainBidderAlert>(fieldAlerts),
      csParamsSchema: mapParametersSchema(csSchema),
      domain: {
        ...domain,
        alerts: alertsFromDTO<DomainAlert>(alerts),
      },
      s2sParamsSchema: mapParametersSchema(s2sSchema),
    }
  })
